export default [
    {
        title: "mainmenu.settings",
        route: "settings",
        icon: "gear",
        class: "d-none d-sm-block",
        resource: "settings",
        action: "read",
    },
];
